import { HttpRequest } from "../utils"

const httpRequest = new HttpRequest()

export const list = async (data: any) => {
  return httpRequest.post("/ord/network/list", data)
}

export const excel = async (data: any) => {
  return httpRequest.post("/ord/network/excel", data)
}

export const get = async (id: string) => {
  return httpRequest.get(`/ord/network/${id}`)
}

export const select = async (data: any) => {
  return httpRequest.get(`/ord/network/select`, data)
}

// Spec §2.7 — TR-level config override sidecar.

export type SlaPriority = "VIP" | "URGENT" | "HIGH" | "NORMAL" | "LOW"

export interface INetworkConfigOverride {
  networkId: string
  businessId: string
  coBusinessId: string
  slaPriority: SlaPriority | null
  channelLabelOverrides: Record<string, string> | null
  carrierPreference: Record<string, unknown> | null
  preferredWarehouseId: string | null
  preferredDriverUserId: string | null
}

export interface INetworkConfigOverrideInput {
  slaPriority?: SlaPriority | null
  channelLabelOverrides?: Record<string, string> | null
  carrierPreference?: Record<string, unknown> | null
  preferredWarehouseId?: string | null
  preferredDriverUserId?: string | null
}

export const getConfigOverride = async (networkId: string): Promise<INetworkConfigOverride | null> => {
  return httpRequest.get(`/ord/network/${networkId}/config-override`)
}

export const upsertConfigOverride = async (
  networkId: string,
  input: INetworkConfigOverrideInput,
): Promise<INetworkConfigOverride> => {
  return httpRequest.put(`/ord/network/${networkId}/config-override`, input as any)
}

// Spec §2.7 — preferred defaults lookup keyed by (caller, coBusinessId).
// Returns the override row or null if none / no network exists.
export const preferredDefaults = async (
  coBusinessId: string,
): Promise<INetworkConfigOverride | null> =>
  httpRequest.get(`/ord/network/preferred-defaults`, { coBusinessId })
